import action1 from './plazmaterapie_01_20.jpg';
import action2 from './permalip_01_20.jpg';
import action3 from './labioplastika_01_20.jpg';

export default [
  undefined, action1, action2, action3
]



// WEBPACK FOOTER //
// ./src/assets/img/akce/index.js